import { connect } from "react-redux";

import Overview from "../../components/main_components/overview";
import { regulationDetailClick } from  "../../actions/focus_view";
import { tableMainRegulationsSorted, tableMainRegulationsPage } from "../../../shared/actions/filters";

const mapStateToProps = (state) => {
  const regulations = state.loading.data.regulations;
  const page = state.filters.tables.mainRegulations.page;
  const sorted = state.filters.tables.mainRegulations.sorted;
  const totalResults = state.loading.data.regulationsTotal;
  const pageSize = state.loading.data.regulationsPageSize;

  return { regulations, page, sorted, totalResults, pageSize };
};

const mapDispatchToProps = dispatch => ({
  regulationDetailClick: regulationDetailClick(dispatch),
  onPageChange: (e) => dispatch(tableMainRegulationsPage(e)),
  onSortedChange: (e) => dispatch(tableMainRegulationsSorted(e))
});

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
